export default __webpack_public_path__ + "static/media/finish-app.64b1789f.png";